import { render, staticRenderFns } from "./CreateCustomerForm.vue?vue&type=template&id=77bb7042&scoped=true&"
import script from "./CreateCustomerForm.vue?vue&type=script&lang=js&"
export * from "./CreateCustomerForm.vue?vue&type=script&lang=js&"
import style0 from "./CreateCustomerForm.vue?vue&type=style&index=0&id=77bb7042&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77bb7042",
  null
  
)

export default component.exports